module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/5GAzsJ/tc-custom/9781460333440.jpg?1699984821987",
      "alt": "This image is the cover for the book Scars of Betrayal, Men of Danger"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Scars of Betrayal, Men of Danger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The long-kept secret "), _c('br'), _c('br'), _vm._v("Cassandra Northrup had believed Nathaniel deaduntil now. Once, she had loved him, given herself to him in the hidden depths of the snow-covered Pyrenees. But then she had betrayed him. "), _c('br'), _c('br'), _vm._v("Relief at the sight of Nathaniel turns to darkest shame as Cassie sees the hate in his eyes. Years have passed and their physical scars have faded, but the pain runs deeper than ever. Yet passion can be born out of betrayaland as desire crackles between them once more, will Cassie reveal the secret she's long kept hidden? "), _c('br'), _c('br'), _vm._v("\"Intriguing, sexyher hero will win hearts.\" RT Book Reviews on The Dissolute Duke")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sophia James\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0